export const ADVANTAGES_LIST: string[] = [
	'0% комісії - КП «Харківські теплові мережі»',
	'0% комісії - КП «Харківводоканал»',
	'0% комісії - КП «Комплекс з вивозу побутових відходів»',
	'0% комісії - КП «Житлокомсервіс»',
	'0 грн відкриття та обслуговування картки',
	'0 грн поповнення будь-яким способом',
];
